const PROJECT_VERSION_COMPANY_DISPLAY_NAMES = new Map<string, string>([
    ["3diemme", "3DIEMME"],
    ["btk3d", "BTK"],
    ["idievolution", "IDIEvolution"],
    ["ipd", "IPD"],
    ["jdental", "JDentalCare"],
    ["medentis", "Medentis"],
    ["oxy", "OXY"],
    ["sweden-martina", "Sweden&Martina"],
    ["zimmerbiomet", "ZimVie"],
    ["zimvie", "ZimVie"],
    ["degoetzen", "Acteon"],
    ["biomax", "Biomax"],
    ["3pguide", "3P"],
    ["iess", "IESS"],
    ["itakad", "Itaka"],
    ["3dlynx", "88dent"],
    ["prodent", "Prodent"],
    ["newancorvisstyle", "New Ancorvis"],
    ["realguide", "3DIEMME"],
    ["default", "3DIEMME"],
    ["zimmer-eu", "3DIEMME"],
]);

export function normalizeVersionCompany(value?: string): string | undefined {
    if (typeof value !== "string") {
        return undefined;
    }

    const trimmedValue = value.trim();
    if (!trimmedValue) {
        return undefined;
    }

    const normalizedCode = trimmedValue.toLowerCase();
    const displayName = PROJECT_VERSION_COMPANY_DISPLAY_NAMES.get(normalizedCode);
    if (displayName) {
        return displayName;
    }

    if (normalizedCode.includes("zimmer")) {
        return "ZimVie";
    }

    return trimmedValue.charAt(0).toUpperCase() + trimmedValue.slice(1);
}
